/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/cloud-backup`, controller.plan, makeLayout, render);
    router(`/dashboard/cloud-backup/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/cloud-backup/subscribe`, controller.newPlan, makeLayout, render);
};
